import { render, staticRenderFns } from "./KoioteSetReset.vue?vue&type=template&id=af158226&lang=es&"
import script from "./KoioteSetReset.vue?vue&type=script&lang=js&"
export * from "./KoioteSetReset.vue?vue&type=script&lang=js&"
import style0 from "./KoioteSetReset.vue?vue&type=style&index=0&id=af158226&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports